import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

// DRUG_LIST_UPDATE_UPDATE_ATTACHMENT

const mutation = gql`
  mutation drugListUpdateRequestUpdateAttachment(
    $id: ID!
    $attachment: DrugListUpdateRequestUpdateAttachmentInput!
  ) {
    drugListUpdateRequestUpdateAttachment(id: $id, attachment: $attachment) {
      id
      form_attachment {
        id
        title
        notes
      }
    }
  }
`
export default function useDrugListUpdateRequestUpdateAttachment() {
  const { onMutate: onDrugListUpdateRequestAttachmentUpdate, loading } =
    useSafeRunMutation({
      mutation,
      responsePath: 'drugListUpdateRequestUpdateAttachment',
      successMessage: 'Attachment updated'
    })

  return { onDrugListUpdateRequestAttachmentUpdate, loading }
}
